import apiClient from '@/api/apiClient';
import type { RiskProfileCreatePayload, RiskProfileInstanceDraftPayload, ProfileGroupListParams } from '@/types/risk-profile';

export default {
  riskModelTemplates: {
    list(params: ProfileGroupListParams = {}) {
      return apiClient.get('/system-admin/risk-model-templates', { params: params as Record<string, any> })
    },
    get(groupId: string) {
      return apiClient.get(`/system-admin/risk-model-templates/${groupId}`)
    },
    create(data: RiskProfileCreatePayload) {
      return apiClient.post('/system-admin/risk-model-templates', data)
    },
    createDraft(groupId: string, data: RiskProfileInstanceDraftPayload) {
      return apiClient.post(`/system-admin/risk-model-templates/${groupId}/instances`, data)
    },
    promoteDraft(groupId: string, instanceId: string) {
      return apiClient.post(
        `/system-admin/risk-model-templates/${groupId}/instances/${instanceId}/promote`,
        {},
      )
    },
    activate(groupId: string) {
      return apiClient.post(`/system-admin/risk-model-templates/${groupId}/activate`, {})
    },
    deactivate(groupId: string) {
      return apiClient.post(`/system-admin/risk-model-templates/${groupId}/deactivate`, {})
    },
    setReleaseAsProduction(groupId: string, instanceId: string) {
      return apiClient.post(
        `/system-admin/risk-model-templates/${groupId}/set-as-production/${instanceId}`,
        {},
      )
    },
    discardDraft(groupId: string) {
      return apiClient.delete(`/system-admin/risk-model-templates/${groupId}/instances/draft`)
    },
    setDesignatedInstance(groupId: string, instanceId: string) {
      return apiClient.post(
        `/system-admin/risk-model-templates/${groupId}/set-designated-instance/${instanceId}`,
        {},
      )
    },
    delete(groupId: string) {
      return apiClient.delete(`/system-admin/risk-model-templates/${groupId}`)
    },
  },
  globalRoles: {
    list() {
      return apiClient.get('/system-admin/roles')
    },
    create(data: any) {
      return apiClient.post('/system-admin/roles', data)
    },
    update(roleId: string, data: any) {
      return apiClient.patch(`/system-admin/roles/${roleId}`, data)
    },
    delete(roleId: string) {
      return apiClient.delete(`/system-admin/roles/${roleId}`)
    },
  },
  deploymentInfo: {
    get() {
      return apiClient.get<{
        image_tag: string | null;
        deployment_timestamp: string | null;
      }>('/system-admin/deployment-info')
    },
  },
}
